// extracted by mini-css-extract-plugin
export var numberInputContainer = "_81-0";
export var startPickingButton = "_81-1";